import {Stack, Typography} from '@mui/material';
import {CancelTwoTone, CheckCircleTwoTone} from '@mui/icons-material';

interface ValidationMessageProps {
  isValid: boolean;
  message: string;
}

const ValidationMessage = ({isValid, message}: ValidationMessageProps) => {
  return (
    <Stack direction='row' spacing={1} color={isValid ? 'green' : 'red'}>
      {isValid ? (
        <CheckCircleTwoTone fontSize='small' />
      ) : (
        <CancelTwoTone fontSize='small' />
      )}
      <Typography variant='caption'>{message}</Typography>
    </Stack>
  );
};

export default ValidationMessage;
